"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _Loader = _interopRequireDefault(require("../../../ui/Loader"));
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _OpenHotelButton = require("../../../OpenHotelButton");
var _actions = require("../../store/actions");
var _selectors = require("../../store/selectors");
var _List = _interopRequireDefault(require("../List"));
var _Collection = _interopRequireDefault(require("../Collection"));
var _Hotel = _interopRequireDefault(require("../Hotel"));
var _modalStyles = _interopRequireDefault(require("../modalStyles.scss"));
var _back = _interopRequireDefault(require("./back.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var getHotelsIDsByCountryID = function getHotelsIDsByCountryID(countryID) {
  return function (hotels) {
    return R.call(R.pipe(R.filter(function (_ref) {
      var country = _ref.country;
      return country.id === countryID;
    }), R.map(R.prop('id'))), hotels);
  };
};
var SelectForSearchCollectionsModal = function SelectForSearchCollectionsModal(_ref2) {
  var countryID = _ref2.countryID,
    initialSelectedHotels = _ref2.selectedHotels,
    currency = _ref2.currency,
    onClose = _ref2.onClose;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('SELECT_FOR_SEARCH_COLLECTIONS_MODAL'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openCollectionID = _useState2[0],
    setOpenCollectionID = _useState2[1];
  var _useState3 = (0, _react.useState)(initialSelectedHotels),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedHotels = _useState4[0],
    setSelectedHotels = _useState4[1];
  var collectionsSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getCollectionsByCountry)(), [{
      countryID: countryID
    }]);
  }, [countryID]);
  var ui = (0, _reactRedux.useSelector)(_selectors.getFetchCollectionsUI);
  var collections = (0, _reactRedux.useSelector)(collectionsSelector);
  var openCollection = (0, _react.useMemo)(function () {
    return openCollectionID && R.find(function (_ref3) {
      var id = _ref3.id;
      return R.equals(id, openCollectionID);
    }, collections);
  }, [openCollectionID, collections]);
  var handleAddAllCollectionHotels = function handleAddAllCollectionHotels(hotels) {
    return R.call(R.pipe(getHotelsIDsByCountryID(countryID), onClose), hotels);
  };
  var toggleHotel = function toggleHotel(id) {
    return setSelectedHotels(R.ifElse(R.includes(id), R.filter(function (ownID) {
      return ownID !== id;
    }), R.append(id)));
  };
  var handleCloseModal = function handleCloseModal() {
    return onClose(selectedHotels);
  };
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.getCollections)());
    return function () {
      return dispatch((0, _actions.clearCollections)());
    };
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeIcon: true,
    className: _modalStyles.default.collectionsModal,
    onClose: handleCloseModal
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, openCollection ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    className: _modalStyles.default.backButton,
    type: "button",
    onClick: function onClick() {
      return setOpenCollectionID(false);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _back.default
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _modalStyles.default.openCollectionHeader
  }, openCollection.name, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      return handleAddAllCollectionHotels(openCollection.hotels);
    }
  }, t('CHANGE_ALL_BUTTON')))) : t('TITLE')), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, null, ui.loading && /*#__PURE__*/_react.default.createElement(_Loader.default, {
    inverted: true,
    label: t('DOWNLOAD_INDICATOR_TEXT')
  }), openCollection ? /*#__PURE__*/_react.default.createElement(_List.default, null, R.map(function (_ref4) {
    var id = _ref4.id,
      name = _ref4.name,
      image = _ref4.image,
      city = _ref4.city,
      country = _ref4.country,
      stars = _ref4.stars;
    var isDisabled = countryID !== country.id;
    return /*#__PURE__*/_react.default.createElement(_Hotel.default, {
      active: !isDisabled && R.includes(id, selectedHotels),
      cityName: city.name,
      disabled: isDisabled,
      image: image,
      key: id,
      name: name,
      stars: stars,
      onClick: !isDisabled ? function () {
        return toggleHotel(id);
      } : undefined,
      onOpenHotelPage: !isDisabled ? function () {
        return (0, _OpenHotelButton.openHotelPage)({
          hotelID: id,
          currency: currency
        });
      } : undefined
    });
  }, openCollection.hotels)) : ui.completed && R.isEmpty(collections) ? 'EMPTY_STATE' : /*#__PURE__*/_react.default.createElement(_List.default, null, R.map(function (_ref5) {
    var id = _ref5.id,
      hotels = _ref5.hotels,
      name = _ref5.name,
      type = _ref5.type,
      withoutHotelsByCountry = _ref5.withoutHotelsByCountry;
    return /*#__PURE__*/_react.default.createElement(_Collection.default, {
      active: !withoutHotelsByCountry && R.and(!R.isEmpty(hotels), R.call(R.pipe(R.filter(function (_ref6) {
        var country = _ref6.country;
        return country.id === countryID;
      }), R.all(function (hotel) {
        return R.includes(hotel.id, selectedHotels);
      })), hotels)),
      disabled: withoutHotelsByCountry,
      hotels: hotels,
      key: id,
      name: name,
      type: type,
      onArrowButtonClick: !withoutHotelsByCountry ? function () {
        return setOpenCollectionID(id);
      } : undefined,
      onClick: !withoutHotelsByCountry ? function () {
        return handleAddAllCollectionHotels(hotels);
      } : undefined
    });
  }, collections)), selectedHotels.length > initialSelectedHotels.length && /*#__PURE__*/_react.default.createElement("div", {
    className: _modalStyles.default.createButtonContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    theme: _Button.THEMES.PURPLE,
    onClick: handleCloseModal
  }, t('APPROVE_BUTTON')))));
};
SelectForSearchCollectionsModal.propTypes = {
  countryID: _propTypes.default.number.isRequired,
  selectedHotels: _propTypes.default.arrayOf(_propTypes.default.number).isRequired,
  onClose: _propTypes.default.func.isRequired,
  currency: _propTypes.default.string
};
var _default = exports.default = SelectForSearchCollectionsModal;